import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.petsuitesPurple,
  arrowHoverBgColor: colors.darkViolet,
  arrowForeColor: colors.white,
  arrowPrevMarginRight: '4px',
  arrowNextMarginLeft: '4px',
  highlightColor: colors.graphite,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.petsuitesPurple,
  paginationBorderColor: colors.petsuitesPurple,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.petsuitesPurple,
  heroPaginationInactiveColorVariationC: colors.petsuitesPurple,
  heroPaginationActiveColor: colors.petsuitesPurple,
  heroPaginationBorderColor: colors.darkViolet,
  bgColor: colors.white,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;